import { File, FolderSimple } from 'phosphor-react';
import { formatDateTime, truncateFileName } from '../../format-converter/utils';
import { formatBytes } from '../utils';

function StorageGridView({ items, onOpenFolder, renderItemActions }) {
  if (!items.length) {
    return <p className="text-sm text-slate-500">No items in this folder.</p>;
  }

  return (
    <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
      {items.map((item) => (
        <div key={item.id} className="rounded-xl border border-slate-200 bg-white p-4">
          <div className="mb-3 flex items-start justify-between gap-3">
            {item.type === 'folder' ? (
              <button type="button" className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-amber-100 text-amber-700" onClick={() => onOpenFolder(item.id)}>
                <FolderSimple size={18} weight="bold" />
              </button>
            ) : (
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 text-slate-700">
                <File size={18} weight="bold" />
              </span>
            )}
            {renderItemActions(item)}
          </div>

          {item.type === 'folder' ? (
            <button type="button" className="w-full text-left" onClick={() => onOpenFolder(item.id)}>
              <p className="truncate text-sm font-semibold text-slate-900">{item.name || 'Untitled folder'}</p>
              <p className="mt-1 text-xs text-slate-500">{formatDateTime(item.updatedAt)}</p>
            </button>
          ) : (
            <>
              <p className="truncate text-sm font-semibold text-slate-900" title={item.name || '-'}>
                {truncateFileName(item.name || '-', 40)}
              </p>
              <p className="mt-1 text-xs text-slate-500">{formatBytes(item.size)}</p>
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export default StorageGridView;
